import { Syntax } from '@trlogic/ui-pack';
import { ChangeEvent, Component } from 'react';
import Icon from '../../icons/Icon';
import { FilterSegmentItem } from '../../domain/chart/editor/Segment';

class FormicaFilterItemComponent extends Component<Props, State> {
  public state = new State();

  render() {
    const { filter, onChangeFilterName, removeFilter, remove = true } = this.props;
    const { visible } = this.state;
    return (
      <div className={'flex flex-col w-full items-center cursor-pointer '}>
        <div className={'w-full h-[34px] border flex items-center justify-between px-1 py-1 '}>
          <div className={'flex w-full items-center  gap-x-2 relative'}>
            <input
              value={filter.label}
              onClick={() => this.setState({ visible: !visible })}
              style={{ boxShadow: 'none !important' }}
              onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeFilterName(e, filter)}
              className={'w-full h-[30px] rounded focus:outline-none  outline-none! indent-1  text-f-input-text border-none  bg-white  hover:border-f-purple'}
            />
            <div onClick={() => this.setState({ visible: !visible })} className={'cursor-pointer'}>
              <Icon icon={`${visible ? 'arrow-up' : 'arrow-down'}`} size={16} className={'cursor-pointer'} />
            </div>
            {remove && (
              <div onClick={() => removeFilter(filter)} className={'cursor-pointer'}>
                <Icon icon={'close'} size={16} className={'cursor-pointer'} />
              </div>
            )}
          </div>
        </div>
        <div className={`${visible ? 'flex' : 'hidden'} w-full`}>TODO</div>
      </div>
    );
  }
}

interface Props {
  filter: FilterSegmentItem;
  onChangeFilterName: (e: ChangeEvent<HTMLInputElement>, filter: FilterSegmentItem) => void;
  onChangeSyntax: (filter: FilterSegmentItem, syntax: Syntax) => void;
  removeFilter: (filter: FilterSegmentItem) => void;
  remove?: boolean;
  variables: any;
}

class State {
  visible: boolean = false;
}

export default FormicaFilterItemComponent;
